import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InitalizeService {

  private showSplashScreen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private showUnderConstruction: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private showEnterSplashScreenButton: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private showDisclaimer: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }

  getUnderConstructionSubscription() {
    return this.showUnderConstruction.asObservable();
  }

  getShowDisclaimerSubscription() {
    return this.showDisclaimer.asObservable();
  }

  getEnterSplashScreenButtonSubscription() {
    return this.showEnterSplashScreenButton.asObservable();
  }

  getSplashScreenSubscription() {
    return this.showSplashScreen.asObservable();
  }

  getSplashScreenLoadingSubscription() {
    return this.loading.asObservable();
  }

  setSplashScreen(show: boolean) {
    this.showSplashScreen.next(show);
  }

  setUnderConstructionScreen(show: boolean) {
    this.showUnderConstruction.next(show);
  }

  setSplashScreenLoading(show: boolean) {
    this.loading.next(show);
  }

  setEnterSplashScreenButton(show: boolean) {
    this.showEnterSplashScreenButton.next(show);
  }

  setShowDisclaimer(show: boolean) {
    this.showDisclaimer.next(show);
  }
}
